import React, { useState, useEffect, useRef } from "react";
import "./about.css";
import "aos/dist/aos.css"; // Import AOS CSS
import { gsap } from "gsap";
import AOS from "aos"; // ✅ Import AOS
import { FaChevronDown } from "react-icons/fa";
import aboutimg from '../../../img/about-img.png';
import logo1 from '../../../img/codeqlik_partner1.png';
import logo2 from '../../../img/codeqlik_partner10.PNG';
import logo3 from '../../../img/codeqlik_partner11.png';
import logo4 from '../../../img/codeqlik_partner12-removebg-preview.png';
import logo5 from '../../../img/codeqlik_partner2.png';
import logo6 from '../../../img/codeqlik_partner3.png';
import logo7 from '../../../img/codeqlik_partner4.png';
import logo8 from '../../../img/codeqlik_partner5-removebg-preview.png';
import logo9 from '../../../img/codeqlik_partner6.png';
import logo10 from '../../../img/codeqlik_partner7.jpeg';
import logo11 from '../../../img/codeqlik_partner8-removebg-preview.png';
import logo12 from '../../../img/logo-14.jpeg';
import logo13 from '../../../img/logo2.jpeg';
import logo14 from '../../../img/logo-3.jpeg';
import logo15 from '../../../img/logo-5.jpeg';
import logo16 from '../../../img/logo-4.jpeg';
import logo17 from '../../../img/logo13.jpeg';
import logo18 from '../../../img/codeqlik_partner1.png';
import founder from '../../../img/md-rashid-modified.jpeg';
import partner1 from '../../../img/Shopify logo.png';
import partner2 from '../../../img/download__1_-removebg-preview.png';
import partner3 from '../../../img/download__2_-removebg-preview.png';
import partner4 from '../../../img/meta logo.png';
import partner5 from '../../../img/download__3_-removebg-preview.png';
import partner6 from '../../../img/download__4_-removebg-preview.png';
import team1 from '../../../img/Teach-haed.avif';
import team2 from '../../../img/Designer & Developer.avif';
import team3 from '../../../img/Coding Ninja  .avif';
import team4 from '../../../img/coding silver.avif';
import { TweenLite, Circ } from 'gsap';

const imagesRow1 = [
  logo1,
  logo2,
  logo3,
  logo4,
  logo5,
  logo6,
  logo7,
  logo8,
  logo9,
  logo10,
  logo11,
];

const imagesRow2 = [
  logo12,
  logo13,
  logo14,
  logo15,
  logo16,
  logo17,
  logo18,
];

const words = [
  "Customer Support",
  "Passion",
  "Positive Experience",
  "Trustworthiness",
  "Customer Focus",
  "Long-term Relation",
  "Innovation",
  "Collaboration",
  "Personalization",
  "Reliability",
  "Quality"
];
// Time line 
const timelineData = [
  {
    step: '01',
    tag: 'step 01',
    title: 'Discovery Phase',
    description:
      'During this initial stage, we delve deep into understanding your business goals, target audience, and market landscape. We conduct thorough research and analysis to identify opportunities and challenges, laying the foundation for a successful campaign.'
  },
  {
    step: '02',
    tag: 'step 02',
    title: 'Strategy Development',
    description:
      'With insights gathered from the discovery phase, we develop a customized strategy tailored to your specific needs and objectives. This comprehensive plan outlines the key tactics, channels, and timelines needed to achieve your business goals effectively.'
  },
  {
    step: '03',
    tag: 'step 03',
    title: 'Implementation and Execution',
    description:
      'Once the strategy is finalized and approved, we roll up our sleeves and put the plan into action. Our expert team utilizes cutting-edge tools and techniques to execute each component of the strategy with precision and efficiency.'
  },
  {
    step: '04',
    tag: 'step 04',
    title: 'Monitoring and Optimization',
    description:
      'Continuous monitoring and optimization are essential to ensuring the success and effectiveness of our campaigns. We closely track key performance indicators and adjust the strategy accordingly.'
  }
];

// Accordion 
const faqData = [
  {
    question: "What services does your company offer?",
    answer:
      "We offer a wide range of IT services, including website development, mobile app development, digital marketing, software development, staff augmentation, and UI/UX design."
  },
  {
    question: "Do you work with startups as well as established enterprises?",
    answer:
      "Yes, we cater to both startups and established businesses. Our flexible service models are designed to meet the specific needs of clients, regardless of their size."
  },
  {
    question: "Can you handle international projects?",
    answer:
      "Yes, we have experience working with clients globally, and we ensure seamless communication and project management across different time zones."
  },
  {
    question: "What platforms do you use for website development?",
    answer:
      "We develop websites using modern platforms and frameworks such as Laravel, CodeIgniter, Shopify, WordPress, and the MERN stack (MongoDB, Express.js, React, Node.js)."
  },
  {
    question: "Will the website be optimized for search engines (SEO)?",
    answer:
      "Yes, we ensure SEO optimization with proper meta tags, fast loading speeds, mobile responsiveness, and schema markup to improve search engine rankings."
  },
  {
    question: "Do you develop apps for both Android and iOS?",
    answer:
      "Yes, we develop native apps for both Android and iOS, as well as cross-platform apps using Flutter and React Native for faster development and lower costs."
  },
  {
    question: "How do you measure the success of digital marketing campaigns?",
    answer:
      "We use key performance indicators (KPIs) such as website traffic, conversion rates, click-through rates (CTR), and return on investment (ROI) to measure the success of our campaigns."
  }
];




function About() {


  // slider//
  const row1Ref = useRef(null);
  const row2Ref = useRef(null);

  useEffect(() => {
    const startInfiniteScroll = (ref, speed, direction) => {
      if (!ref.current) return;

      const inner = ref.current.querySelector(".slider-inner");
      const slides = Array.from(inner.children);

      // Clone slides for seamless effect
      slides.forEach((slide) => {
        let clone = slide.cloneNode(true);
        inner.appendChild(clone);
      });

      // Get total width dynamically
      let totalWidth = inner.scrollWidth / 2;

      gsap.set(inner, { x: direction === "left" ? "0%" : `-${totalWidth}px` });

      gsap.to(inner, {
        x: direction === "left" ? `-${totalWidth}px` : "0%",
        duration: speed,
        ease: "linear",
        repeat: -1,
      });
    };

    startInfiniteScroll(row1Ref, 30, "left");
    startInfiniteScroll(row2Ref, 30, "right");
  }, []);

  //   circle//
  const circleRef = useRef(null);

  useEffect(() => {
    const animateWords = () => {
      const wordElements = document.querySelectorAll(".word");
      wordElements.forEach((word, index) => {
        setTimeout(() => {
          word.style.opacity = "1";
          word.style.transform = "translateY(0)";
        }, index * 300);
      });
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            animateWords();
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.5 }
    );

    if (circleRef.current) {
      observer.observe(circleRef.current);
    }
  }, []);
  //   FAQ//


  const [aboutActiveIndex, setAboutActiveIndex] = useState(null);
  const toggleAboutAccordion = (index) => {
    setAboutActiveIndex(aboutActiveIndex === index ? null : index);
  };
  // Fade Animation on scroll//
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);








  useEffect(() => {
    const timelineEl = document.querySelector('.timeline');
    const handleScroll = () => {
      const rect = timelineEl.getBoundingClientRect();
      if (rect.top <= window.innerHeight && rect.bottom >= 0) {
        timelineEl.classList.add('animate-track');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);


  const timelineRef = useRef(null);
  const trackRef = useRef(null);
  const [visibleItems, setVisibleItems] = useState([]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const viewPoint = scrollTop + window.innerHeight * 0.5;

      const items = document.querySelectorAll('.timeline__item');
      const visible = [];

      items.forEach((item, idx) => {
        const top = item.offsetTop;
        const bottom = top + item.offsetHeight;

        if (viewPoint > top && viewPoint < bottom) {
          visible.push(idx);
        } else if (viewPoint > bottom) {
          visible.push(idx);
        }
      });

      setVisibleItems(visible);
      updateTrack();
    };

    const updateTrack = () => {
      if (!trackRef.current || !timelineRef.current) return;

      const timelineTop = timelineRef.current.offsetTop;
      const scrollY = window.scrollY + window.innerHeight * 0.5;

      // Get the total height of the timeline section
      const sectionHeight = timelineRef.current.offsetHeight;

      // Calculate the desired height for the track
      const desiredHeight = scrollY - timelineTop;

      // Make sure the track height does not exceed the section height
      const finalHeight = Math.min(desiredHeight, sectionHeight);

      trackRef.current.style.height = `${finalHeight > 0 ? finalHeight : 0}px`;
    };


    window.addEventListener('scroll', handleScroll);
    window.addEventListener('resize', handleScroll);

    handleScroll();


  }, []);







  return (
    <div>


      <section className="header-bg">
        <div className="container-fluid">
          <div className="top-header">
            <img src={aboutimg} alt="About" />
          </div>
          <div className="top-header-text text-center fade-in-top">
            <div className="header-text">
              <h2>
                Hey There! Welcome to
                <br /> CodeQlik Technolab!
              </h2>
            </div>
          </div>
        </div>
      </section>
      <section className="about-bg">
        <div className="container-fluid">
          <div className="row">
            {/* Left Section */}
            <div className="col-lg-6 col-md-12 fixed-column fixedheigth">
              <div className="text-center mb-5 mt-1" data-aos="fade-up" data-aos-delay="0">
                <div className="why-header">
                  <span>Who We Are</span>
                  <h1>About Our Company</h1>
                </div>
              </div>

              <div className="mt-5">
                <div className="we-are-text">
                  <p className="ptext1">
                    At CodeQlik, we specialize in delivering cutting-edge web and app development solutions tailored
                    to meet the dynamic needs of businesses. With a passion for innovation and a commitment to
                    excellence, we craft digital experiences that not only look stunning but also perform flawlessly.
                  </p>
                  <p className="ptext2">
                    At CodeQlik, we believe in empowering businesses with technology, ensuring seamless user
                    experiences, and driving measurable results. With a team of seasoned professionals, we are your
                    partners in building a strong digital foundation for your brand.
                  </p>
                  <p className="ptext3">
                    Let's elevate your digital presence. Choose CodeQlik for innovation that counts!
                  </p>
                </div>
              </div>
            </div>

            {/* Right Section - Accordion */}
            <div className="col-lg-6 col-md-12 scrollable-column" data-aos="fade-up" data-aos-delay="100">
              <div className="accordionB">
                {/* Accordion Item - Our History */}
                <div className={`accordion-itemA${aboutActiveIndex === 0 ? ' active' : ''}`}>
                  <div className="accordion-header" onClick={() => toggleAboutAccordion(0)}>
                    <h2>01. Our History</h2>
                    <span className="caret-box">
                      <i className={`fa-solid ${aboutActiveIndex === 0 ? 'fa-minus' : 'fa-plus'}`}></i>
                    </span>
                  </div>
                  <div className="accordion-content">
                    {aboutActiveIndex === 0 && (
                      <>
                        <p>
                          CodeQlik began its journey in 2018 with a vision to revolutionize the digital landscape. Founded by a
                          team of passionate tech enthusiasts, our company started as a small venture focused on delivering
                          creative web solutions to local businesses.
                        </p>
                        <p>
                          Over the years, CodeQlik has grown into a trusted name in the industry, driven by a commitment to
                          quality, innovation, and customer satisfaction. Today, we take pride in being a digital partner for
                          businesses of all sizes, helping them achieve success in an ever-evolving technological world.
                        </p>
                      </>
                    )}
                  </div>
                </div>

                {/* Accordion Item - Our Mission */}
                <div className={`accordion-itemA${aboutActiveIndex === 1 ? ' active' : ''}`}>
                  <div className="accordion-header" onClick={() => toggleAboutAccordion(1)}>
                    <h2>02. Our Mission</h2>
                    <span className="caret-box">
                      <i className={`fa-solid ${aboutActiveIndex === 1 ? 'fa-minus' : 'fa-plus'}`}></i>
                    </span>
                  </div>
                  <div className="accordion-content">
                    {aboutActiveIndex === 1 && (
                      <>
                        <p>
                          At CodeQlik, our mission is to empower businesses by delivering innovative, reliable, and high-quality digital solutions. We strive to:
                        </p>
                        <p>1. Enhance Digital Experiences: Create user-centric web and app solutions that combine seamless functionality with exceptional design.</p>
                        <p>2. Drive Business Growth: Equip businesses with cutting-edge technology and strategic marketing to achieve their goals and expand their reach.</p>
                        <p>3. Foster Innovation: Continuously explore emerging technologies to provide future-ready solutions.</p>
                        <p>4. Build Lasting Relationships: Prioritize customer satisfaction by maintaining transparency, trust, and excellence in every project.</p>
                      </>
                    )}
                  </div>
                </div>

                {/* Accordion Item - Our Vision */}
                <div className={`accordion-itemA${aboutActiveIndex === 2 ? ' active' : ''}`}>
                  <div className="accordion-header" onClick={() => toggleAboutAccordion(2)}>
                    <h2>03. Our Vision</h2>
                    <span className="caret-box">
                      <i className={`fa-solid ${aboutActiveIndex === 2 ? 'fa-minus' : 'fa-plus'}`}></i>
                    </span>
                  </div>
                  <div className="accordion-content">
                    {aboutActiveIndex === 2 && (
                      <>
                        <p>
                          At CodeQlik, our vision is to be a global leader in providing innovative, sustainable, and impactful digital solutions that shape the future of businesses. We aim to:
                        </p>
                        <p>1. Transform Industries: Lead the way in redefining how businesses interact with technology, setting new standards of excellence and innovation.</p>
                        <p>2. Empower Businesses Worldwide: Help companies of all sizes and industries unlock their full potential through customized, forward-thinking digital strategies.</p>
                        <p>3. Foster Digital Innovation: Continuously explore and implement emerging technologies to create solutions that are not just relevant today but also future-proof.</p>
                        <p>4. Be a Trusted Partner: Build lasting relationships with our clients by providing exceptional service, transparency, and measurable results.</p>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="clients">
        <div className="brands-about mt-5 text-center">
          <div className="text-center py-5" data-aos="fade-up" data-aos-delay="0">
            <span className="gallery-text text-uppercase ">BRANDS</span>
            <div className="brands-heading">
              <h1>Brands we have<br /> worked with</h1>
            </div>
          </div>
        </div>
        <hr />
        <div className="slider-container">


          {/* First row */}
          <div className="slider-row slider-row-left" ref={row1Ref}>
            <div className="slider-inner">
              {imagesRow1.map((src, index) => (
                <div className="slider-card" key={index}>
                  <img src={src} alt="logo" />
                </div>
              ))}
            </div>
          </div>

          {/* Second row */}
          <div className="slider-row slider-row-right" ref={row2Ref}>
            <div className="slider-inner">
              {imagesRow2.map((src, index) => (
                <div className="slider-card" key={index}>
                  <img src={src} alt="logo" />
                </div>
              ))}
            </div>
          </div>

        </div>
        <hr />


      </section>
      <section className="sec-3-bg">
        <div className="container-fluid px-4">
          {/* <!-- Section Title --> */}
          <div className="text-center mb-5 mt-1" data-aos="fade-up" data-aos-delay="0">
            <div className="why-header">
              <span>About Founder</span>
              <h1> Meet The Founder</h1>
            </div>
          </div>

          <p className="subheading">
            MD Rashid, the heart of CodeQlik Technologies. With a decade of digital marketing expertise, Rashid's passion
            for innovation and dedication to clients have guided our journey. His strategic vision, client-centered
            approach, and knack for creative solutions shape our commitment to excellence.
          </p>

        </div>
      </section>

      <section className="sec-3-bg">
        <div className="container">
          <div className="row">
            {/* <!-- Founder Image --> */}
            <div className="col-lg-4 col-md-12 text-center founder-image" data-aos="fade-up" data-aos-delay="0">
              <img src={founder} alt="Founder Image" />
              <h2 className="founder-name mt-3">MD <br /> <span>Rashid</span></h2>
            </div>

            {/* <!-- Founder Description --> */}
            <div className="col-lg-8 col-md-12" data-aos="fade-up" data-aos-delay="100">

              <p className="subheading1">
                MD Rashid, the driving force behind CodeQlik Technologies. With over a decade of experience in digital
                marketing, Rashid's passion for innovation and dedication to client success have been the cornerstone of our
                company's growth. His strategic vision and hands-on approach have propelled us to the forefront of the
                industry. As a respected leader and mentor, Rashid inspires us to exceed expectations and deliver
                exceptional results for our clients every day.
              </p>

              {/* <!-- Badges --> */}
              <div className="d-flex mt-5">
                <p className="badge"><i className="fa-solid fa-atom"></i>Visionary Thinker</p>
                <p className="badge"><i className="fa-solid fa-atom"></i>Empathetic Leader</p>
              </div>
              <div className="d-flex">
                <p className="badge"><i className="fa-solid fa-atom"></i>Creative Problem-Solver</p>
                <p className="badge"><i className="fa-solid fa-atom"></i>Passionate Mentor</p>
              </div>

              <div className="partners-section">
                <h2>Partnered with:</h2>
                <div className="partners-grid">
                  <div className="partner-card">
                    <img src={partner1} alt="Shopify" />
                  </div>
                  <div className="partner-card">
                    <img src={partner2} alt="Influencer" />

                  </div>
                  <div className="partner-card">
                    <img src={partner3} alt="Digital Voices" />

                  </div>
                  <div className="partner-card">
                    <img src={partner4} alt="Meta" />

                  </div>
                  <div className="partner-card">
                    <img src={partner5} alt="Later" />

                  </div>
                  <div className="partner-card">
                    <img src={partner6} alt="Zapier" />

                  </div>
                </div>
              </div>
            </div>


          </div>
        </div>
      </section>

      <section className="values">
        <div className="values-section" data-aos="fade-up" data-aos-delay="0">
          <div className="background-text">VALUES</div>

          <div className="box-mainA">


            {/* <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Customer Support</div>
            <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Passion</div>
            <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Positive Experience</div>
            <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Trustworthiness</div>
            <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Customer Focus</div>
            <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Long-term Relation </div>
            <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Innovation</div>
            <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Collaboration</div>
            <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Personalization</div>
            <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Reliability</div>
            <div className="word"><img width="48" height="48" src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah"/> Quality</div> */}
            <div className="box-main">
              <div className="circle-container" ref={circleRef}>
                {words.map((word, index) => (
                  <div key={index} className="word word-{index+1}">
                    <img
                      width="18"
                      height="18"
                      src="https://img.icons8.com/external-tanah-basah-glyph-tanah-basah/48/external-Atom-education-tanah-basah-glyph-tanah-basah.png"
                      alt="icon"
                    />
                    {word}
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>


      </section>


      {/* <div className="container " data-aos="fade-up" data-aos-delay="0">
    <div className="we-work-text text-center my-5">
      <span className="we-work-tag">How We Work</span>
      <h2 className="mt-2">Our 4 Stage Process</h2>
    </div> */}
      <div className="container " data-aos="fade-up" data-aos-delay={0}>
        <div className="text-center my-5">
          <span className="we-work-tag">How We Work</span>
          <h2 className="mt-2 text-white">Our 4 Stage Process</h2>
        </div>
      </div>
      <section className="timeline-section">
        <div className="medium-container">
          <div className="timeline" ref={timelineRef}>
            {timelineData.map((item, idx) => (
              <div
                key={idx}
                className={`timeline__item ${visibleItems.includes(idx) ? 'is-visible' : ''
                  }`}
              >
                <div className="timeline__line"></div>
                <div className="timeline__wrap">
                  <div
                    className={
                      idx % 2 === 0 ? 'timeline-step' : 'timeline-step2'
                    }
                  >
                    {item.step}
                  </div>
                  <span className="step-tag">{item.tag}</span>
                  <h5>{item.title}</h5>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}

            <div className="timeline__track" ref={trackRef}></div>
          </div>
        </div>
      </section>

      <section className="team-bg mt-5">
        <div className="container-fluid">
          <div className="text-center mb-5" data-aos="fade-up" data-aos-delay="0">
            <span className="gallery-text text-uppercase ">Team Members</span>
            <h2 className="choose-text-heading">Say Hello to Our<br /> Squad</h2>
            <p className="ourteam">Get ready to meet the faces behind the magic, the <br /> dreamers, and the doers driving our
              success.</p>
          </div>


          <div className="row">
            <div className="col-lg-4 col-md-6 col-12" data-aos="fade-up" data-aos-delay="0">
              <div className="teamdescription">
                <h1>Tech head</h1>
                <p className="team-desg">Sr.Designer & Developer</p>
                <img src={team1} alt="Vinod Saini" />
              </div>
              <div className="name-section">
                <h3>Vinod Saini</h3>
                <p>Tech Head</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-12" data-aos="fade-up" data-aos-delay="100">
              <div className="teamdescription">
                <h1>Visionary</h1>
                <p className="team-desg">Designer & Developer</p>
                <img src={team2} alt="Renu Sain" />
              </div>
              <div className="name-section">
                <h3>Renu Sain</h3>
                <p>Project Manager</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-12" data-aos="fade-up" data-aos-delay="200">
              <div className="teamdescription">
                <h1>Mastermind</h1>
                <p className="team-desg">Coding Ninja</p>
                <img src={team3} alt="Afreen Hussain" />
              </div>
              <div className="name-section">
                <h3>Afreen Hussain</h3>
                <p>Senior Developer</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6 col-12" data-aos="fade-up" data-aos-delay="300">
              <div className="teamdescription">
                <h1>Excellent</h1>
                <p className="team-desg">Coding Silver</p>
                <img src={team4} alt="Mohd. Abbas Ali" />
              </div>
              <div className="name-section">
                <h3>Mohd. Abbas Ali</h3>
                <p>Developer</p>
              </div>
            </div>
          </div>
          <div className="row">

          </div>

        </div>
      </section>

      <section className="gallery-section gallery-bg">
        <div className="container-fluid py-4">
          <div className="text-center mb-5 mt-1" data-aos="fade-up" data-aos-delay="0">
            <div className="why-header">
              <span>GALLERY</span>
              <h1>Our Company Gallery</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-4 d-none d-md-block"></div>
            <div className="col-lg-4 d-none d-md-block"></div>
            <div className="col-lg-4 col-md-12 col-12">
              <p className="snapspara">From team outings and office shenanigans to special events and celebrations, these photos
                capture the essence of
                our vibrant culture and the bonds that unite us.</p>
            </div>
          </div>


        </div>
      </section>

      <section>
        <div className="container-fluid">
          <div className="row">
            <div className="first-box-1">
              <div className="box box1"></div>
              <div className="box box2"></div>
            </div>
            <div className="first-box-2">
              <div className="box box3"></div>
              <div className="box box4"></div>
            </div>
            <div className="first-box-3">
              <div className="box box5"></div>
              <div className="box box6"></div>
            </div>

          </div>

        </div>

      </section>
      <section className="accordion-bg pt-5">
        <div className="we-work-text text-center my-5">
          <span className="we-work-tag">Frequently Asked Questions</span>
          <h2 className="mt-4">Got Questions <br /> We've Got Answers!</h2>
        </div>


        {faqData.map((item, index) => (
          <div key={index}
            className={`accordion-itemB ${aboutActiveIndex === index ? "active" : ""}`}
          >
            <div className="accordion-header" onClick={() => toggleAboutAccordion(index)}>
              <h3>{item.question}</h3>
              <div className="caret-box">
                <FaChevronDown
                  className={`caret ${aboutActiveIndex === index ? "rotate" : ""}`} />
              </div>
            </div>
            <div className="accordion-content"
              style={{ maxHeight: aboutActiveIndex === index ? "150px" : "0" }}>
              <p>{item.answer}</p>
            </div>
          </div>
        ))}
      </section>
    </div>
  )
}

export default About